module.exports = __webpack_public_path__ + "static/york_main_1-996943b50da2d0279f347fa5ec3f9869.jpg";